import React, { useState, useContext, useEffect, useRef } from "react";
import "./Reports.css";
import axios from "axios";
import { Button } from "@progress/kendo-react-buttons";
import { useSelector, useDispatch } from "react-redux";
import { getFeatureWithId, getMapLayerById } from "../utils/mapUtils";
import { dataAPI } from "../../api/axios";
import { makeArray } from "../../permissionUtils";
import MapContext from "../MapContext";
import { RxCaretRight } from "react-icons/rx";
import { screenShotMap } from "../Print/printUtils";
import { getCenter } from "ol/extent";

import { dynamicSort, dynamicSortMultiple, login } from "./ReportsUtil";

const Reports = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const layerVisProperties = useSelector(
        (state) => state.configData.layerVisProperties
    );
    const currentResults = useSelector((state) => state.resultsData.results);

    var serverTokenKey = "TelerikReportServerToken";
    const serverHost = process.env.REACT_APP_REPORT_SERVER_URL;
    const serverApi = serverHost + "/api/reportserver/v2/";
    const { map } = useContext(MapContext);
    useEffect(() => {
        if (!mapConfig) {
        } else {
        }
    }, [mapConfig]);

    const [selectedReport, setSelectedReport] = useState();
    const [reportStatus, setReportStatus] = useState();
    const [lastReportID, setLastReportID] = useState();
    useEffect(() => {
        setReportStatus(null);
        if (selectedReport) {
        }
    }, [selectedReport]);

    function getSelectedRecords(layerID, allowSelectAll) {
        if (currentResults) {
            let a = currentResults.find((i) => i.Id === layerID);
            if (a) {
                return a.Features;
            }
        }
        if (allowSelectAll) {
            return getMapLayerById(map, selectedReport.LayerID).getSource().getFeatures();
        } else {
            return null;
        }
    }
    function getSelectedRecordsCount(layerID, allowSelectAll) {
        if (currentResults) {
            let a = currentResults.find((i) => i.Id === selectedReport.LayerID);
            if (a) {
                return a.Features.length;
            }
        }
        if (allowSelectAll) {
            return getMapLayerById(map, selectedReport.LayerID).getSource().getFeatures()
                .length;
        } else {
            return 0;
        }
    }

    function mapFields(record, map) {
        if (!map) {
            return "";
        }
        let jsx = map;
        for (const property in record.values_) {
            if (typeof property === "string") {
                jsx = jsx.replaceAll(`{${property}}`, record.values_[property] ?? "");
            }
        }
        return jsx;
    }
    function convertArrayToJSON(arr) {
        return JSON.stringify(arr, function (key, value) {
            if (Array.isArray(value) || typeof value === "object") {
                return value;
            }
            return value;
        });
    }

    function screenShotmapPromise(map, imageArgs, printCallback, fm) {
        return new Promise((resolve, rejects) => {
            screenShotMap(map, imageArgs, printCallback, {}, fm.ID, resolve);
        });
    }

    async function generateReportData(selectedReport) {
        const promises = [];
        const output = [];

        if (selectedReport.Type === "LayerReport") {
            const records = getSelectedRecords(
                selectedReport.LayerID,
                selectedReport.AllowSelectAll ?? false
            );

            let dataTableArr = [];
            let featureMapArr = [];

            if (selectedReport.Fields.DataTable) {
                dataTableArr = makeArray(selectedReport.Fields.DataTable);
            }
            if (selectedReport.Fields.Map) {
                featureMapArr = makeArray(selectedReport.Fields.Map);
            }

            for (const i in records) {
                const outObj = {};
                const record = records[i];
                let vr = record;
                if (typeof record === "string") {
                    vr = getFeatureWithId(map, selectedReport.LayerID, record);
                }

                selectedReport.Fields.Field.forEach((field) => {
                    outObj[field.OutField] = mapFields(vr, field.Map);
                });
                output.push(outObj);

                dataTableArr.forEach((dt) => {
                    promises.push(
                        dataAPI
                            .get(
                                `/Layers/${selectedReport.LayerID}/Data/${vr.id_}/DataLink/${dt.DataLinkID}`
                            )
                            .then((d) => (outObj[dt.OutField] = d.data[dt.DataLinkID]))
                    );
                });

                for (const i in featureMapArr) {
                    const fm = featureMapArr[i];
                    const imageArgs = createImageArgs(vr, fm);
                    await screenShotmapPromise(
                        map,
                        imageArgs,
                        (e, data) => {
                            outObj[fm.OutField] = data.map;
                        },
                        fm
                    );
                }
            }
        } else if (selectedReport.Type === "SiteReport") {
            const outObj = {};
            //Loop over each data query inside Fields Tags
            makeArray(selectedReport.Fields.DataQuery).forEach((element) => {
                promises.push(
                    dataAPI.get(`/DataQuery/${element.ID}/Data`).then((d) => {
                        //If DataQuery has an attribute called Root place the value at the top level of the json output
                        //The dataquery should only return 1 row else the last row will be used in the ouput
                        //Else just add the data as array of object to be handle by subreports in the report
                        if (element.Root) {
                            Object.assign(outObj, d.data[0]);
                        } else {
                            outObj[element.OutField] = d.data;
                        }
                    })
                );
            });
            output.push(outObj);
        }
        Promise.all(promises).then(async () => {
            //Sort Data
            if (selectedReport.SortBy) {
                let sortByArr = makeArray(selectedReport.SortBy.SortField);
                output.sort(dynamicSortMultiple(...sortByArr.map((i) => i.Name)));
            }

            var response = await axios.post(
                process.env.REACT_APP_LAYER_API_BASEURL + "/Reports",
                { jsonData: convertArrayToJSON(output) }
            );

            var accessToken = await login(
                process.env.REACT_APP_TELERIK_USERNAME,
                process.env.REACT_APP_TELERIK_PASSWORD
            );
            window.sessionStorage.setItem(serverTokenKey, accessToken);
            let reportParameters = { docID: response.data.id };
            //Check for and add any Parameter additional Report Parameters tags from the config file
            if (selectedReport.Parameters) {
                makeArray(selectedReport.Parameters.Parameter).forEach((element) => {
                    reportParameters[element.Name] = element.Value;
                });
            }
            await exportDocument(selectedReport.ReportID, "PDF", reportParameters, true);
            setReportStatus("Download");
        });
    }

    async function exportDocument(reportId, format, parameterValues, asAttachment) {
        if (!reportId) {
            window.alert("Please, select a report.");
        }

        const data = {
            ReportId: reportId,
            Format: format,
            DeviceInfo: {},
            ParameterValues: parameterValues,
        };

        const token = window.sessionStorage.getItem(serverTokenKey);
        const headers = {};

        if (token) {
            headers.Authorization = "Bearer " + token;
        }

        try {
            const response = await axios.post(serverApi + "documents", data, {
                headers: headers,
            });

            const documentId = response.data;
            setLastReportID(documentId);
            let queryString = "";
            if (asAttachment) {
                queryString += "content-disposition=attachment";
            }

            const exportUrl = serverApi + "documents/" + documentId + "?" + queryString;
            window.open(exportUrl);
        } catch (error) {
            console.error(error);
        }
    }

    async function runReport(selectedReport) {
        setReportStatus("Running");
        await generateReportData(selectedReport);
    }

    async function downloadReport() {
        let queryString = "";
        queryString += "content-disposition=attachment";
        const exportUrl = serverApi + "documents/" + lastReportID + "?" + queryString;
        window.open(exportUrl);
    }

    return (
        <>
            <h4>Reports</h4>

            {!mapConfig && !mapConfig.Reports && mapConfig.Reports.length > 0 && (
                <p>No Reports Available</p>
            )}

            {mapConfig && mapConfig.Reports && !selectedReport && (
                <>
                    {/*<p>{mapConfig.Reports.length} Reports Available</p>*/}
                    {mapConfig.Reports.map((report) => (
                        <>
                            <div
                                className="report-item"
                                key={
                                    report.LayerID ??
                                    "SiteReport" + "_" + report.ReportID + "_div"
                                }
                                onClick={(e) => {
                                    setSelectedReport(report);
                                }}>
                                <h3>{report.DisplayName}</h3>
                                <button
                                    className="menu-report"
                                    key={
                                        report.LayerID ??
                                        "SiteReport" + "_" + report.ReportID + "_button"
                                    }
                                    onClick={(e) => {
                                        setSelectedReport(report);
                                    }}>
                                    <RxCaretRight />
                                </button>
                                {report.Description}
                            </div>
                        </>
                    ))}
                </>
            )}
            {selectedReport && (
                <>
                    {" "}
                    <h3>{selectedReport.DisplayName}</h3>
                    {selectedReport.Description}
                    <>
                        <br />
                    </>
                    {selectedReport.Type === "LayerReport" && (
                        <>
                            {getSelectedRecordsCount(
                                selectedReport.LayerID,
                                selectedReport.AllowSelectAll ?? false
                            )}{" "}
                            of{" "}
                            {
                                getMapLayerById(map, selectedReport.LayerID)
                                    .getSource()
                                    .getFeatures().length
                            }
                        </>
                    )}
                    {!reportStatus &&
                        (getSelectedRecordsCount(
                            selectedReport.LayerID,
                            selectedReport.AllowSelectAll ?? false
                        ) !== 0 ||
                            selectedReport.Type === "SiteReport") && (
                            <>
                                <div
                                    className="report-item"
                                    key={
                                        selectedReport.LayerID +
                                        "_" +
                                        selectedReport.ReportID +
                                        "_Rundiv"
                                    }
                                    onClick={(e) => {
                                        runReport(selectedReport);
                                    }}>
                                    <h3>Run</h3>
                                </div>
                            </>
                        )}
                    {reportStatus === "Running" && (
                        <>
                            <div
                                className="report-item"
                                key={
                                    selectedReport.LayerID +
                                    "_" +
                                    selectedReport.ReportID +
                                    "_Runningdiv"
                                }>
                                <h3>Running</h3>
                            </div>
                        </>
                    )}
                    {reportStatus === "Download" && (
                        <>
                            <div
                                className="report-item"
                                key={
                                    selectedReport.LayerID +
                                    "_" +
                                    selectedReport.ReportID +
                                    "_Downloaddiv"
                                }
                                onClick={(e) => {
                                    downloadReport(selectedReport);
                                }}>
                                <h3>Download</h3>
                            </div>
                            <div
                                className="report-item"
                                key={
                                    selectedReport.LayerID +
                                    "_" +
                                    selectedReport.ReportID +
                                    "_ReRundiv"
                                }
                                onClick={(e) => {
                                    runReport(selectedReport);
                                }}>
                                <h3>Run Again</h3>
                            </div>
                        </>
                    )}
                    <div
                        className="report-item"
                        key={
                            selectedReport.LayerID +
                            "_" +
                            selectedReport.ReportID +
                            "_Backdiv"
                        }
                        onClick={(e) => {
                            setSelectedReport(null);
                        }}>
                        <h3>Back</h3>
                    </div>
                </>
            )}
        </>
    );
};
export default Reports;

const createImageArgs = (feature, fm) => {
    const extent = feature.values_.geometry.extent_;
    const center = getCenter(extent);
    const bufferedCoords = bufferExtent(extent, fm.BufferDistance);
    const yDist = bufferedCoords[3] - bufferedCoords[1];
    const xDist = bufferedCoords[2] - bufferedCoords[0];
    let resolution = 0;
    if (xDist / yDist > fm.Width / fm.Height) {
        const pixels = fm.Width * 96;
        resolution = xDist / pixels;
    } else {
        const pixels = fm.Height * 96;
        resolution = yDist / pixels;
    }

    const imageArgs = {
        resolution: resolution,
        center: center,
        dimensions: [fm.Width * 96, fm.Height * 96],
    };
    return imageArgs;
};

const bufferExtent = (extent, buffer) => {
    const xMin = extent[0] - buffer;
    const yMin = extent[1] - buffer;
    const xMax = extent[2] + buffer;
    const yMax = extent[3] + buffer;
    return [xMin, yMin, xMax, yMax];
};
